<template>
    <resource-index ref="resourceIndex" title="Счета на оплату" :endpoint="endpoint">
        <template v-slot:table-header>
            <tr class="border-b">
                <th class="text-left p-3 px-5" scope="col">Внешний ID</th>
                <th class="text-left p-3 px-5" scope="col">Статус</th>
                <th class="text-left p-3 px-5" scope="col">Дата</th>
                <th class="text-left p-3 px-5" scope="col"></th>
                <th class="text-left p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:row="slotProps">
            <td class="p-3 px-5">
                <span
                    class="badge whitespace-no-wrap badge-indigo"
                >Заказ #{{ slotProps.entry.external_id }}</span>
            </td>

            <td class="p-3 px-5">
                <span
                    class="badge whitespace-no-wrap badge-success"
                    v-if="slotProps.entry.status == 'paid'"
                >Оплачен</span>
                <span
                    class="badge whitespace-no-wrap badge-gray"
                    v-if="slotProps.entry.status == 'pending'"
                >Ожидание</span>
                <span
                    class="badge whitespace-no-wrap badge-warning"
                    v-if="slotProps.entry.status == 'cancelled'"
                >Отменен</span>
            </td>

            <td
                class="p-3 px-5"
            >{{ localTime(slotProps.entry.paid_at ? slotProps.entry.paid_at : slotProps.entry.created_at) }}</td>

            <td class="p-3 px-5">
                <button
                    v-if="slotProps.entry.status !== 'paid'"
                    class="btn btn-danger"
                    @click="cancel(slotProps.entry)"
                >Отменить</button>
            </td>

            <td class="p-3 px-5">
                <router-link
                    :to="{
                        name: 'admin.billing.invoices.show',
                        params: {
                            id: slotProps.entry.id
                        }
                    }"
                    class="btn btn-info"
                >Открыть</router-link>
            </td>
        </template>
    </resource-index>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
    components: {
        ResourceIndex
    },

    data() {
        return {
            endpoint: `/admin/billing/orders/${this.$route.params.id}/invoices`
        };
    },

    methods: {
        cancel(entry) {
            if (!confirm("Подтвердите действие")) {
                return false;
            }

            axios
                .delete(`admin/billing/invoices/${entry.id}`)
                .then(response => {
                    this.$refs.resourceIndex.updateEntry(response.data.data);
                });
        }
    },

    mounted() {}
};
</script>